import * as React from "react";
import { Dispatch, lazy, Suspense, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import UpgradePlanDialog from "../components/UpgradePlan/UpgradePlanDialog";
// new redux code
//import { useSelector, useDispatch } from "react-redux";
import { setItem } from "../store/localActions";

import useIsMounted from "ismounted";

// @ts-ignore
import Tooltip from "../components/Tour/Tooltip";
import Sidebar from "./Sidebar";
import Header from "./Header";
import AppLoader from "../components/Loader/AppLoader";
import UserAPIs from "../apis/user.apis";
import ScrollController from "./ScrollController";
import { iStoreAction } from "../redux/reducers";
import { AppDispatchContext, AppStateContext, NotificationContext } from "../App";
import { Scrollbar } from "../components/CustomScroll/ScrollBars";
import Axios from "axios";
import ResetPassword from "./Login/Forgot/ResetPassword";
import Register from "./Login/Register/Register";
import { HideBetterDoc, ShowBetterDoc } from "../components/common";
import GettingStarted from "../components/GettingStarted/GettingStarted";
import { HomeTour } from "../components/Tour/Pages/Home.Tour";
import ShopifyPermissionRequired from "../components/ShopifyPermissionRequired/ShopifyPermissionRequired";
import ShopifyThemeEmbedRequired from "../components/ShopifyThemeEmbedRequired/ShopifyThemeEmbedRequired";
import qs from 'qs';
import RegisterHome from "./Login/Register/Register.Home";
import { AppBottomBannerRow, AppBottomBannerStack } from "../components/TopBar";
import { shopErrorBannerKey } from "../i18n/shopErrorBanner";
import { Drawer } from "@material-ui/core";
import SwipeableEWDrawer from "../components/Drawer";
import CommonApis from "../apis/common.apis";
import { setEmailwishApiToken } from "../utils/emailwishApiToken";


const TalkToAnAgent = lazy(() => import('./TalkToAnAgent/TalkToAnAgent'));
const Videos = lazy(() => import('./Help/Videos'));
const Temp = lazy(() => import('./temp/Temp'));
const DashboardRoutes = lazy(() => import('./Dashboard/Dashboard.Routes'));
const EmailRoutes = lazy(() => import('./Email/Email.Routes'));
const ChatRoutes = lazy(() => import('./Chats/Chats.Routes'));
const ShopifyRoutes = lazy(() => import('./Shopify/Shopify.Routes'));
const PopupRoutes = lazy(() => import('./Popup/Popup.Routes'));
const AccountRoutes = lazy(() => import('./Account/Account.Routes'));
const ReviewsRoutes = lazy(() => import('./Reviews/Reviews.Routes'));
const WishlistRoutes = lazy(() => import('./Wishlist/Wishlist.Routes'));

const CreateNewPassword = lazy(() => import('./Login/CreateNewPassword'));
const ForgotPassword = lazy(() => import('./Login/Forgot/ForgotPassword'));

const Reload = lazy(() => import('./Reload'));
const RegisterComplete = lazy(() => import('./Login/Register/Register.Complete'));
const Login = lazy(() => import('./Login/Login/Login'));
const AcceptInvite = lazy(() => import('./Login/AcceptInvite/AcceptInvite'));
const ReviewUpdate = lazy(() => import('./Public/ReviewUpdate/Review.Update'));


function Router() {
    const { t } = useTranslation("common");

//     const dispatchRedux  = useDispatch();
//   const profileSetting = useSelector((state : any) => state.local.profileSetting ?? {});
//     const setProfileSetting = (data : any) => {
//         dispatchRedux(setItem("profileSetting",data))
//     }
    const lastFetchPathRef = useRef<string>("");
    const sessionHydratedRef = useRef(false);

    const dispatch: Dispatch<iStoreAction> = useContext(AppDispatchContext);

    const history = useHistory();
    const location = useLocation();

    const isMounted = useIsMounted();
    const [loading, setLoading] = useState(true);    

        const [development, setDevelopment] = useState(false);
        const [error, setError] = useState<undefined | 'error' | 'info' | 'warning' | 'success' | null>(null);
        const [errorMessage, setErrorMessage] = useState('');


    const notificationContext = useContext(NotificationContext);

    const { shop, loggedInUser, profileSetting } = useContext(AppStateContext);

    sessionHydratedRef.current = Boolean(loggedInUser && shop?.customer_uid);

    /** Sending/features disabled: API sets `shop.active` to suspended or blocked (or legacy numeric 2/3) */
    const shopActive = shop?.active != null ? String(shop.active).toLowerCase() : "";
    const shopAccountRestricted =
        ["suspended", "blocked", "2", "3"].includes(shopActive);
    const shopApprovedOverride = shop?.customer?.flag === "over_ridden";
    // Hide suspect note for the first 12h after customer creation (onboarding grace).
    const customerCreatedAtMs = shop?.customer?.created_at
        ? Date.parse(shop.customer.created_at)
        : NaN;
    const showSuspectBanner =
        shop?.customer?.flag === "suspect" &&
        !shopApprovedOverride &&
        Number.isFinite(customerCreatedAtMs) &&
        Date.now() - customerCreatedAtMs >= 12 * 60 * 60 * 1000;
    const shopErrorI18nKey = shopErrorBannerKey(shop?.active, errorMessage);
    const load_modules_settings = useCallback(() => {
        new UserAPIs().modules_status().then((res) => {
            if (isMounted.current) {
                if (UserAPIs.hasError(res, undefined)) {

                } else {
                    // Only apply defined booleans so we never clear optimistic toggle state.
                    if (typeof res.popup_module_enabled === "boolean") {
                        dispatch({ type: "popup_enabled", enabled: res.popup_module_enabled })
                    }
                    if (typeof res.chat_module_enabled === "boolean") {
                        dispatch({ type: "chat_enabled", enabled: res.chat_module_enabled })
                    }
                    if (typeof res.review_module_enabled === "boolean") {
                        dispatch({ type: "review_enabled", enabled: res.review_module_enabled })
                    }
                    dispatch({ type: "wishlist_enabled", enabled: res.wishlist_module_enabled })
                }
            }

        })
    }, []);

    useEffect(() => {
        const handleInvalidToken = (e: StorageEvent) => {
            if (e.key !== 'set_active_shop_uid') return;
            const valueChanged = e.newValue !== e.oldValue;
            const wasCleared = e.oldValue != null && e.newValue == null;
            if (valueChanged || wasCleared) {
                window.location.reload();
            }
        };
        window.addEventListener('storage', handleInvalidToken);
        return () => window.removeEventListener('storage', handleInvalidToken);
    }, []);

    // simple affiliate check and redirect to store link
    useEffect(() => {
        const qsParams = qs.parse(location.search, { ignoreQueryPrefix: true });
        const via = qsParams.via;
        const goto = qsParams.goto;
        if (via && goto) {
            console.log("goto",goto);
            const url = new URL(`https://apps.shopify.com/emailmarketing_emailwish_abandonedcart_popup_chat_reviews?via=${via}`);
            window.location.replace(url.toString());
        }    
    }, []);


    useEffect(() => {
        if (!shop?.customer_uid) {
            return;
        }

        Axios.defaults.headers["X-Emailwish-Customer-UID"] = shop.customer_uid;

        const devPlans = ["affiliate", "true", "partner_test", "staff", "preview", "developer_preview"];
        setDevelopment(devPlans.includes(shop.mode));
        setError(shop.error ?? null);
        setErrorMessage(shop.error_message ?? "");
    }, [shop])


    const onFetchUser = useCallback((options?: { silent?: boolean }) => {
        const onRegisterPath = location.pathname.includes("/register");
        const onGuestAuthPath =
            location.pathname.includes("/login") ||
            location.pathname.includes("/forgot-password") ||
            location.pathname.includes("/password/reset");

        if (!options?.silent && !onRegisterPath && !onGuestAuthPath && !sessionHydratedRef.current) {
            setLoading(true);
        }

        new UserAPIs().fetch_user().then((response) => {
            if (!isMounted.current) {
                return;
            }

            if (UserAPIs.hasError(response)) {
                // Auth/session failure → clear sticky client session and land on login
                // (never register). Backend may still return redirectURL=/login.
                if (localStorage.getItem("logged_in") === "true") {
                    dispatch({ type: "logout" });
                }
                return;
            }

            if (response.user) {
                new CommonApis().after_login(response, dispatch);
            } else if (localStorage.getItem("logged_in") === "true") {
                dispatch({ type: "logout" });
            }

            const qsParams = qs.parse(location.search, { ignoreQueryPrefix: true });
            const redirect = qsParams.redirect;

            if (redirect) {
                delete qsParams.redirect;
                const newQueryString = qs.stringify(qsParams);
                response.redirectURL = redirect + "?" + newQueryString;
            }

            if (response.redirectURL && response.redirectURL.length > 0) {
                const pathHasRegister = location.pathname.includes("/register");
                const onDashboard =
                    location.pathname === "/dashboard" ||
                    location.pathname.startsWith("/dashboard/");
                const isLoggedIn = localStorage.getItem("logged_in") === "true";

                if (response.redirectURL.includes("myshopify.com")) {
                    window.location.href = response.redirectURL;
                    return;
                }

                const isRegisterResume = response.redirectURL.includes("/register/complete");
                const isLoginRedirect = response.redirectURL.includes("/login");

                if (isLoginRedirect && (isLoggedIn || sessionHydratedRef.current)) {
                    return;
                }

                // Chat-only agents get redirectURL=/chats as login landing — don't bounce them
                // off Account / Chats / Invite when current_user refreshes mid-session.
                const chatOnlyLanding =
                    response.redirectURL === "/chats" || response.redirectURL === "/chats/";
                const alreadyOnAllowedPath =
                    location.pathname.startsWith("/chats") ||
                    location.pathname.startsWith("/account") ||
                    location.pathname.startsWith("/invite");
                if (chatOnlyLanding && alreadyOnAllowedPath) {
                    return;
                }

                const shouldRedirect =
                    !pathHasRegister &&
                    !(onDashboard && isRegisterResume) &&
                    !(onDashboard && isLoginRedirect);

                if (shouldRedirect) {
                    if (response.redirectURL.startsWith("http")) {
                        window.location.assign(response.redirectURL);
                    } else {
                        history.push(response.redirectURL);
                    }
                }
            }
        }).finally(() => {
            if (isMounted.current) {
                setLoading(false);
            }
        });
    }, [isMounted, location.pathname, history, dispatch]);

    useEffect(() => {
        if (loggedInUser && shop?.customer_uid) {
            load_modules_settings();
        }
    }, [loggedInUser, shop?.customer_uid, load_modules_settings])

    // Ingest SSO token from URL parameters (e.g. from WordPress admin /_woocommerce/autologin)
    useEffect(() => {
        const qsParams = qs.parse(location.search, { ignoreQueryPrefix: true });
        const autoLoginToken = (qsParams.token || qsParams.api_token) as string | undefined;

        if (autoLoginToken && typeof autoLoginToken === "string" && autoLoginToken.trim().length > 0) {
            setEmailwishApiToken(autoLoginToken.trim());
            localStorage.setItem("logged_in", "true");

            if (qsParams.uid && typeof qsParams.uid === "string") {
                localStorage.setItem("set_active_shop_uid", qsParams.uid);
            }

            // Clean token from address bar to prevent leaking in history/referrers
            delete qsParams.token;
            delete qsParams.api_token;
            const remaining = qs.stringify(qsParams);
            const cleanUrl = location.pathname + (remaining ? `?${remaining}` : "");
            history.replace(cleanUrl);

            lastFetchPathRef.current = "";
            onFetchUser();
        }
    }, [location.search, location.pathname, history, onFetchUser]);

    useEffect(() => {
        const qsParams = qs.parse(location.search, { ignoreQueryPrefix: true });
        const isOAuthBootstrapInProgress =
            location.pathname.includes("/register/complete") &&
            Boolean(qsParams.code && qsParams.shop);

        if (isOAuthBootstrapInProgress) {
            setLoading(false);
            // Do not hydrate a stale logged_in session during Shopify OAuth —
            // Register.Complete waits for step_one to emit sessionEstablished.
            if (localStorage.getItem("logged_in") === "true") {
                localStorage.removeItem("logged_in");
            }

            const handleSessionReady = () => {
                lastFetchPathRef.current = "";
                onFetchUser({ silent: true });
            };
            window.addEventListener("onboarding:session-ready", handleSessionReady);

            return () => {
                window.removeEventListener("onboarding:session-ready", handleSessionReady);
            };
        }

        const onRegisterPath = location.pathname.includes("/register");
        const onGuestAuthPath =
            location.pathname.includes("/login") ||
            location.pathname.includes("/forgot-password") ||
            location.pathname.includes("/password/reset");
        const isLoggedIn = localStorage.getItem("logged_in") === "true";

        if ((onRegisterPath || onGuestAuthPath) && !isLoggedIn) {
            setLoading(false);
            const fetchKey = `${location.pathname}${location.search}`;
            if (fetchKey !== lastFetchPathRef.current) {
                lastFetchPathRef.current = fetchKey;
                onFetchUser({ silent: true });
            }
            return;
        }

        const fetchKey = `${location.pathname}${location.search}`;
        if (fetchKey === lastFetchPathRef.current && sessionHydratedRef.current) {
            setLoading(false);
            return;
        }
        lastFetchPathRef.current = fetchKey;

        onFetchUser();
    }, [location.pathname, location.search, onFetchUser]);

    const isRegisterPath = location.pathname.includes("/register");
    const isGuestAuthPath =
        location.pathname.includes("/login") ||
        location.pathname.includes("/forgot-password") ||
        location.pathname.includes("/password/reset") ||
        location.pathname.includes("/invite/");
    if (loading && !isRegisterPath && !isGuestAuthPath) {
        return null;
    }
    return <ScrollController>
        <Suspense fallback={<AppLoader />}>
            <Switch>
                <Route path="/register/complete" component={RegisterComplete} />
                <Route path="/register" component={Register} />
                <Route path="/reload" component={Reload} />
                <Route path="/tmp" component={Temp} />

                <Route path="/review/update/:uid/:secret" component={ReviewUpdate} />
                {/*<NotLoggedRoutes path="/create-new-password"><CreateNewPassword/></NotLoggedRoutes>*/}
                <NotLoggedRoutes path="/forgot-password"><ForgotPassword /></NotLoggedRoutes>
                <NotLoggedRoutes path="/password/reset/:token"><ResetPassword /></NotLoggedRoutes>
                <NotLoggedRoutes path="/login"><Login /></NotLoggedRoutes>
                <Route path="/invite/:token" component={AcceptInvite} />

                <PrivateRoute path="/">
                    {(showSuspectBanner || shopAccountRestricted || shopApprovedOverride || development || error !== null) && (
                        <AppBottomBannerStack>
                            {shopApprovedOverride && (
                                <AppBottomBannerRow
                                    message={t("dashboard.accountApprovedBanner")}
                                    type="success"
                                />
                            )}
                            {showSuspectBanner && (
                                <AppBottomBannerRow
                                    message={t("dashboard.suspectAccountBanner")}
                                    type="warning"
                                />
                            )}
                            {shopAccountRestricted && !shopApprovedOverride && (
                                <AppBottomBannerRow
                                    message={t("dashboard.accountRestrictedBanner")}
                                    type="warning"
                                />
                            )}
                            {development && (
                                <AppBottomBannerRow message={t("dashboard.devModeBanner")} type="warning" />
                            )}
                            {error !== null && !shopApprovedOverride && (
                                <AppBottomBannerRow
                                    message={shopErrorI18nKey ? t(shopErrorI18nKey) : errorMessage}
                                    type={error}
                                />
                            )}
                        </AppBottomBannerStack>
                    )}
                    <UpgradePlanDialog />
                    {/* <Scrollbar removeTrackYWhenNotUsed permanentTrackY={false} className="scrollNewCss" style={{ width: "100%", height: "100vh" }}> */}
                        <Sidebar>
                            {
                                window.location.pathname.includes('add-store') ? null : <Header />
                            }
                            <div className="app-content">
                                
                                <div className="container p-0 mb-2">
                                    {/* <GettingStarted /> */}
                                    <ShopifyPermissionRequired />
                                    <ShopifyThemeEmbedRequired />
                                    <Suspense fallback={<AppLoader />}>
                                        <Switch key={shop?.customer_uid ?? "no-shop"}>
                                            <Route path="/add-store" component={RegisterHome} />
                                            <Route path="/dashboard" component={DashboardRoutes} />
                                            <Route path="/email" component={EmailRoutes} />
                                            <Route path="/chats" component={ChatRoutes} />
                                            <Route path="/reviews" component={ReviewsRoutes} />
                                            <Route path="/wishlists" component={WishlistRoutes} />
                                            <Route path="/popups" component={PopupRoutes} />
                                            <Route path="/account" component={AccountRoutes} />
                                            <Route path="/shopify" component={ShopifyRoutes} />
                                            <Route path="/support" component={TalkToAnAgent} />
                                            <Route path="/videos" component={Videos} />
                                            <Redirect to={"/dashboard"} />
                                        </Switch>
                                    </Suspense>
                                </div>

                            </div>
                            <HomeTour />
                        </Sidebar>
                    {/* </Scrollbar> */}
                </PrivateRoute>
            </Switch>
        </Suspense>
    </ScrollController>;
}

function PrivateRoute({ children, ...rest }: any) {
    const { loggedInUser, shops }: any = useContext(AppStateContext);
    const dispatch = useContext(AppDispatchContext);
    const hasShopAccess = Boolean(loggedInUser && shops && shops.length > 0);

    useEffect(() => {
        if (hasShopAccess) {
            ShowBetterDoc();
        } else {
            HideBetterDoc();
        }
        return () => {
            HideBetterDoc();
        }
    }, [hasShopAccess])

    // Logged-in but no shops is treated as auth failure for the private app shell.
    // Clear sticky session so NotLoggedRoutes does not bounce /login → / → /login.
    useEffect(() => {
        if (loggedInUser && !hasShopAccess) {
            dispatch({ type: "logout" });
        }
    }, [loggedInUser, hasShopAccess, dispatch]);

    if (hasShopAccess) {
        return <Route {...rest}
            render={() =>
                children
            }
        />;
    }

    return <Route {...rest}
        render={({ location }) =>
            <Redirect to={{
                pathname: "/login",
                state: { from: location }
            }}
            />
        }
    />;
}

function NotLoggedRoutes({ children, ...rest }: any) {
    const { loggedInUser, shops }: any = useContext(AppStateContext);
    const isAuthed = Boolean(loggedInUser && shops && shops.length > 0);
    return (
        <Route {...rest}
            render={() =>
                !isAuthed ? (children) : (
                    <Redirect to={{
                        pathname: "/",
                    }}
                    />
                )
            }
        />
    );
}

export default Router;
